<div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper pt-0">
        <div class="content-wrapper d-flex align-items-center auth auth-flex">
            <div class="row flex-grow flex-blocking">
                <div class="col-xs-4 col-lg-4 col-sm-12 col-md-9 mx-auto">
                    <div class="auth-form-light text-left p-5">
                        <div class="brand-logo">
                            <img src="assets/images/full-logo1.png" alt="logo" class="logo-dark" />
                        </div>
                        <form class="pt-3" [formGroup]="formmaster">
                            <div class="form-group">
                                <input type="email" formControlName="username" [class.is-invalid]="this.formmaster.get('username').touched
                  && this.formmaster.get('username').invalid" class="form-control form-control-lg" id="exampleInputEmail1" autocomplete="off" placeholder="Username">
                                <span class="mandatory-span" *ngIf="this.formmaster.get('username').touched &&
                  this.formmaster.get('username').invalid">Username is required</span>
                            </div>
                            <!-- <div class="form-group">
                                <input type="password" formControlName="password" class="form-control form-control-lg" [class.is-invalid]="this.formmaster.get('password').touched
                  && this.formmaster.get('password').invalid" id="exampleInputPassword1" placeholder="Password">
                                <span class="mandatory-span" *ngIf="this.formmaster.get('password').touched &&
                  this.formmaster.get('password').invalid">Password is required</span>
                            </div> -->


                            <div class=" form-group" style="position: relative;" >
                                <input  type="{{ Show ? 'text' : 'password' }}"
                                       id="password"
                                       [class.is-invalid]="formmaster.get('password')?.touched && formmaster.get('password')?.invalid"
                                       formControlName="password"
                                       [placeholder]="'Password'"
                                       class="form-control form-control-lg"
                                       autocomplete="off">
                                <i class="fa" [ngClass]="Show ? 'fa-eye-slash' : 'fa-eye'"
                                   style="cursor: pointer;"
                                   id="show-pwd"
                                   (click)="toggle()"></i>
                                   <span class="mandatory-span"
                                   *ngIf="this.formmaster.get('password').touched && this.formmaster.get('password').invalid">Password
                                  is required</span>
                              </div>
                            <ngx-recaptcha2 #captchaElem [siteKey]="sitekey" class="recaptchass" (reset)="reset()" (expire)="handleExpire()" (load)="handleLoad()" (success)="handleSuccess($event)" [useGlobalDomain]="false" [size]="size" [hl]="lang" [theme]="theme" [type]="type"
                                formControlName="recaptcha">
                            </ngx-recaptcha2>
                            <div class="mt-3">
                                <button (click)="Onclicklogin()" class="btn btn-block btn-primary btn-lg font-weight-medium
                  auth-form-btn save-button">SIGN IN</button>
                            </div>
                            <div class="my-2 d-flex justify-content-between
                align-items-center" style="width:100%;">

                                <a [routerLink]="['/auth/forgotpassword']" class="auth/forgotpassword
                  text-black forgot-button" style="text-align:right;width:100%;">Forgot Password?</a>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
</div>